import {
  Action,
  ActionType,
  SendQuestionnaireResponse,
} from "models/questionnaires/sendQuestionnaires";
import createReducer from "../../createReducer";

export interface SendQuestionnaireReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  sendQuestionnaireResponse?: SendQuestionnaireResponse;
}

const defaultState: SendQuestionnaireReducerType = {
  loading: false,
  error: null,
  saved: false,
  sendQuestionnaireResponse: undefined,
};

export const sendQuestionnaireReducer =
  createReducer<SendQuestionnaireReducerType>(defaultState, {
    [ActionType.SEND_QUESTIONNAIRE](state: SendQuestionnaireReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SEND_QUESTIONNAIRE_ERROR](
      state: SendQuestionnaireReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.SEND_QUESTIONNAIRE_SUCCESS](
      state: SendQuestionnaireReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        sendQuestionnaireResponse: action.payload,
      };
    },

    [ActionType.SEND_QUESTIONNAIRE_RESET](state: SendQuestionnaireReducerType) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        sendQuestionnaireResponse: undefined,
      };
    },
  });
